import SelectionZone from './container/index';

export default SelectionZone;



// WEBPACK FOOTER //
// ./src/components/page/SelectionZone/index.js